import React, { useState, useEffect } from 'react'
import Toggle from 'react-toggle'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'
import clsx from 'clsx'

import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  input: {
    '& > .react-toggle-track': {
      width: 40,
      height: 20,
      backgroundColor: theme.borderColor,
    },
    '& > .react-toggle-thumb': {
      height: 16,
      width: 16,
      border: 'none !important',
      outline: 'none !important',
      top: 2,
      left: 3,
      background: theme.white,
      display: 'flex',
      boxShadow: '0px 1px 3px 0 rgba(0, 0, 0, 0.15)',
    },
    '&.checked > .react-toggle-thumb': {
      left: 21,
    },
    '&.checked > .react-toggle-track': {
      backgroundColor: theme.primaryLight,
    },
    '&.checked:hover > .react-toggle-track': {
      backgroundColor: theme.primaryLight + ' !important',
    },
    '&:hover > .react-toggle-track': {
      backgroundColor: theme.borderColor + ' !important',
    },
  },
  small: {
    '& .react-toggle-track': {
      height: 13,
      width: 20,
      marginTop: 2,
    },
    '& .react-toggle-thumb': {
      height: 9,
      width: 9,
      marginTop: 2,
    },
    '&.checked > .react-toggle-thumb': {
      left: 9,
    },
  },
}))

const ToggleSlider = (props) => {
  const {
    name,
    useFormik,
    useCheckedAsValue,
    small,
    readOnly = false,
    checked = false,
    className,
    dataQsId,
  } = props
  const classes = useStyles()
  const [checkedState, setCheckedState] = useState(checked)

  const formikContext = useFormik === undefined || useFormik ? useFormikContext() : null

  let field = null

  if (formikContext && name) {
    field = formikContext.getFieldProps(name)
    useEffect(() => { setCheckedState(field.value) }, [field])
  } else {
    useEffect(() => { setCheckedState(checked) }, [checked])
  }

  const onChange = (event) => {
    event?.persist()
    const { onChange, checked: currentCheckedValue } = props

    if (useCheckedAsValue) {
      const newValue = !currentCheckedValue
      formikContext && formikContext.setFieldValue(name, newValue)
      onChange && onChange(newValue, name, event)
    } else {
      setCheckedState((currentValue) => {
        const newValue = !currentValue
        formikContext && formikContext.setFieldValue(name, newValue)
        onChange && onChange(newValue, name, event)
        return newValue
      })
    }

  }

  return (
    <Toggle
      className={clsx(classes.input, checkedState && 'checked', small && classes.small, className)}
      defaultChecked={checkedState}
      disabled={readOnly}
      icons={false}
      data-qs-id={dataQsId}
      onChange={onChange}
    />
  )
}

ToggleSlider.propTypes = {
  checked: PropTypes.bool,
  small: PropTypes.bool,
  readOnly: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  useFormik: PropTypes.bool,
  useCheckedAsValue: PropTypes.bool,
  className: PropTypes.string,
  dataQsId: PropTypes.string.isRequired,
}

export default ToggleSlider
